import { Button, message, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Flex, Input } from 'antd';
import type { GetProps } from 'antd';
import { mixPostV1 } from "services/mixin";

type OTPProps = GetProps<typeof Input.OTP>;
const OTPPage = () => {
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get('code');
    const uid = searchParams.get('uid');
    const reactive = searchParams.get('reactive');

    // useEffect(() => {
    //     if (!uid) {
    //         message.error('User ID is missing!');
    //         navigate('/sign-up');
    //     }
    // }, [uid, navigate]);

    const [otpValue, setOtpValue] = useState('');
    async function verifyOtp(otp: string, uid: string | null) {
        try {
            if (!uid) {
                message.error('User ID is missing!');
                return;
            }
            if (otp.length !== 6) {
                message.error('Please enter a valid 6-digit OTP code!');
                return;
            }
            if (!reactive) {
                const res = await mixPostV1('/api/v1/verify-email-otp', {
                    user_id: uid,
                    otp: otp
                });

                if (res.status) {
                    message.success('OTP verified successfully!');
                    navigate('/sign-up/step');
                } else {
                    message.error(res.message || 'OTP verification failed, please try again!');
                }
            }
            else {
                const res = await mixPostV1('/api/v1/complete-verification', {
                    user_id: uid,
                    otp: otp
                });
                if (res.status) {
                    message.success('OTP verified successfully!');
                    localStorage.setItem('token', res.data.access_token);
                    localStorage.setItem('user', JSON.stringify(res.data.info));
                    message.success('Account reactivated successfully!');
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    navigate('/');
                } else {
                    message.error(res.message || 'OTP verification failed, please try again!');
                }
            }
        }
        catch (error) {
            message.error('OTP verification failed, please try again!');
        }
    }

    async function resendOtp(uid: string | null) {
        try {
            if (!uid) {
                message.error('User ID is missing!');
                return;
            }
            const res = await mixPostV1('/api/v1/resend-verification-otp', {
                user_id: uid,
            });
            if (res.status) {
                message.success('OTP resent successfully! Please check your email.');
            } else {
                message.error(res.message || 'Failed to resend OTP, please try again!');
            }
        }
        catch (error) {
            message.error('Failed to resend OTP, please try again!');
        }
    }

    useEffect(() => {
        if (otpValue.length === 6 && uid) {
            verifyOtp(otpValue, uid);
        }
    }, [otpValue]);
    const onChange: OTPProps['onChange'] = async (text) => {
        setOtpValue(text);
    };

    const onInput: OTPProps['onInput'] = (value) => {
        // change every input
    };

    const sharedProps: OTPProps = {
        onChange,
        onInput,
    };

    return (
        <div className="sign-up-page relative min-h-screen overflow-hidden flex items-center justify-center px-4 py-8">
            <div className="fixed inset-0 w-full h-full -z-20">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover"
                >
                    <source src="/video/new-bg-video.mp4" type="video/mp4" />
                    {/* <source src="/video/bg-video.webm" type="video/webm" /> */}
                    Your browser does not support the video tag.
                </video>
            </div>
            {/* Video Overlay */}
            <div className="fixed inset-0 bg-white/10 -z-10"></div>

            <div className='absolute top-4 left-4 cursor-pointer w-38 h-12 md:w-48 md:h-22' onClick={() => navigate('/')}>
                <img className='' src='./images/logo2.png' alt='logo' />
            </div>
            <div className='signUp-container'>
                <div className="flex justify-between lg:max-w-4xl mx-auto">
                    <div className="card-custom !p-4 !bg-transparent !bg-white/5 !backdrop-blur-lg !border !border-white/30 !shadow-2xl !flex-1 rounded-lg">
                        <Typography.Title level={2} className="text-center !text-3xl text-white !mb-8">
                            OTP Verification
                        </Typography.Title>
                        <div className='form'>
                            <p className="text-center text-white mb-4">Please enter the OTP sent to your email.</p>
                            <Flex justify="center" align="center" gap={16}>
                                <Input.OTP
                                    {...sharedProps}
                                    value={otpValue}
                                    onChange={(value) => setOtpValue(value)}
                                    length={6}
                                    size="large"
                                    autoFocus
                                />
                            </Flex>
                        </div>
                        <div className='flex gap-2 flex-row items-center justify-center text-white/90 mt-6'>
                            <p>Didn't receive the code?</p>
                            <p onClick={
                                () => {
                                    resendOtp(uid);
                                }
                            } className="text-white text-decoration-underline font-bold cursor-pointer hover:text-white/80 transition-colors duration-200">
                                Resend
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default OTPPage;